import React from 'react';
import { Navigate } from 'react-router-dom';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import PickUpDropPoints from '@routes/Home/routes/AdminPortal/routes/Transport/routes/PickUpDropPoints';
import TransportShift from '@routes/Home/routes/AdminPortal/routes/Transport/routes/TransportShift';
import Vehicles from '@routes/Home/routes/AdminPortal/routes/Transport/routes/Vehicles';
import CreateNewVehicle from '@routes/Home/routes/AdminPortal/routes/Transport/routes/Vehicles/routes/CreateNewVehicle';
import EditVehicle from '@routes/Home/routes/AdminPortal/routes/Transport/routes/Vehicles/routes/EditVehicle';

const TransportLazy = React.lazy(
	() => import(/* webpackChunkName : 'Transport' */ './components/Transport')
);

export default (store) => {
	return [
		{
			path: 'transport',
			element: <AsyncLoading component={<TransportLazy />} />,
			children: [
				{
					index: true,
					element: <Navigate to="pickup-drop-points" replace />,
				},
				PickUpDropPoints(store),
				TransportShift(store),
				Vehicles(store),
			],
		},
		CreateNewVehicle(store),
		EditVehicle(store),
	];
};
